<div class="slider">
  <splide [options]="sliderOptions" class="slider slider--pink">
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/cricket/slide1.jpg" alt="Slide 1" class="m-auto">
        </div>
        <div class="slider__desc">
          Your <strong>15 coins</strong> relate to <strong>15 things</strong> that can happen in the match. Tap on a coin at any time to see what it is.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/cricket/slide2.jpg" alt="Slide 2" class="m-auto">
        </div>
        <div class="slider__desc">
          <strong>If an event happens</strong> that you have on your card, that <strong>coin turns purple.</strong>
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/cricket/slide3.jpg" alt="Slide 3" class="m-auto">
        </div>
        <div class="slider__desc">
          If you’re <strong>first to get 1 and/or 2 Lines</strong>, you <strong>win a prize.</strong>
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/cricket/slide4.jpg" alt="Slide 4" class="m-auto">
        </div>
        <div class="slider__desc">
          If you’re <strong>first to get all 15 events</strong> happen in the match, you get a Full House, <br /> and you <strong>win the main prizepot.</strong>
        </div>
      </div>
    </splide-slide>
  </splide>
</div>
